import BaseContextMenu from '@components/ContextMenu/BaseContextMenu';
import SpacingContent, { SpacingContentProps } from './SpacingContent';

const SpacingContextMenu = ({
  value,
  onChangeValue,
  onReset,
  onClose,
}: SpacingContentProps) => {
  return (
    <BaseContextMenu onClose={onClose}>
      <SpacingContent
        value={value}
        onChangeValue={onChangeValue}
        onReset={onReset}
        onClose={onClose}
      />
    </BaseContextMenu>
  );
};

export default SpacingContextMenu;
